// Card externo com o markup base da empresa (ADM 12m + impostos Lucro Presumido + lucro padrão).
// Não-interativo aqui — a customização acontece dentro de cada composição.

export default function CardMarkupBase({ data }: { data: any }) {
  const fmtPct = (v: number) => (v ?? 0).toFixed(2) + '%';
  const valid = data.soma_pct < 100 && data.markup_fator > 0;
  const adicional = data.impostos?.irpj_adicional || 0;
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'auto 1fr 1fr 1fr auto', gap: 14,
      alignItems: 'center', padding: '12px 16px', marginBottom: 12,
      background: 'linear-gradient(90deg, #F0F4FF 0%, #FAFBFF 100%)',
      border: '0.5px solid #CDD4EA', borderRadius: 8,
    }}>
      <div>
        <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Markup base</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: valid ? '#020D7F' : '#B91626' }}>
          {valid ? data.markup_fator.toFixed(3) + '×' : '—'}
        </div>
        <div style={{ fontSize: 10, color: '#888' }}>+{(data.acrescimo_pct ?? 0).toFixed(1)}% sobre custo</div>
      </div>
      <Componente label="ADM (12m)" valor={fmtPct(data.adm?.pct)}
        dica={`Indiretos / Receita dos 12 meses até ${data.periodo_referencia?.fim || '—'} (último trimestre fechado)`} />
      <Componente label="Impostos" valor={fmtPct(data.impostos_total_pct)}
        dica={`PIS ${data.impostos.pis}% + COFINS ${data.impostos.cofins}% + IRPJ ${data.impostos.irpj}%${adicional > 0 ? ' + Adicional IRPJ ' + adicional.toFixed(2) + '%' : ''} + CSLL ${data.impostos.csll}% + ISS ${data.impostos.iss}% (Lucro Presumido, serviços)`} />
      <Componente label="Lucro padrão" valor={fmtPct(data.lucro_pct)} dica="Editável dentro de cada composição" />
      <div style={{ fontSize: 10, color: '#666', textAlign: 'right', maxWidth: 200 }}>
        Markup = 1 / (1 − ADM − Impostos − Lucro)<br />
        Soma = <strong>{fmtPct(data.soma_pct)}</strong>
      </div>
    </div>
  );
}

function Componente({ label, valor, dica }: { label: string; valor: string; dica: string }) {
  return (
    <div title={dica} style={{ cursor: 'help' }}>
      <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
      <div style={{ fontSize: 16, fontWeight: 600, color: '#020D7F' }}>{valor}</div>
    </div>
  );
}
